import React, { useState } from "react";
import { Link } from "react-router-dom";
import { REAngleLeft, REAngleRight, REAnglesLeft } from "./icons/IconSvg";

export default function NewCommonPagination({ currentPage, pageSize, totalPages, tableCallBack, data }) {
    const [startPage, setStartPage] = useState(Math.max(currentPage - 3, 1));
    const [endPage, setEndPage] = useState(Math.min(startPage + 6, totalPages));

    const buildUrl = (page) => {
        const url = new URL(data, window.location.origin);
        url.searchParams.set("page", page);
        return url.toString();
    };

    const handleNext = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const nextPage = currentPage + 1;
        if (nextPage <= totalPages) {
            tableCallBack(nextPage);
            if (nextPage > endPage) {
                setStartPage(startPage + 1);
                setEndPage(endPage + 1);
            }
        }
    };
    const handlePages = (page) => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        tableCallBack(page);
    };
    const handlePrevious = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const prevPage = currentPage - 1;
        if (prevPage >= 1) {
            tableCallBack(prevPage);
            if (prevPage < startPage) {
                setStartPage(startPage - 1);
                setEndPage(endPage - 1);
            }
        }
    };

    return (
        <div className="pagination-sec">
            <div className="pagination-inner">
                <ul className="pagination-wrapper">
                    {currentPage !== 1 && (
                        <>
                            <li>
                                <Link
                                    to={buildUrl(1)}
                                    disabled={currentPage === 1}
                                    onClick={() => {
                                        document.documentElement.scrollTop = 0;
                                        document.body.scrollTop = 0;
                                        tableCallBack(1);
                                    }}
                                >
                                    <REAnglesLeft />
                                </Link>
                            </li>
                            <li>
                                <Link to={buildUrl(currentPage - 1)} disabled={currentPage === 1} onClick={handlePrevious}>
                                    <REAngleLeft />
                                </Link>
                            </li>
                        </>
                    )}
                    {totalPages > 1 &&
                        [...Array(totalPages)].map((_, index) => {
                            const page = index + 1;
                            if (page >= startPage && page <= endPage) {
                                return (
                                    <li key={index}>
                                        <Link to={buildUrl(page)} className={currentPage === page ? "active" : ""} onClick={() => handlePages(page)}>
                                            {page}
                                        </Link>
                                    </li>
                                );
                            }
                            return null;
                        })}
                    {currentPage !== totalPages && (
                        <li>
                            <Link to={buildUrl(currentPage + 1)} disabled={currentPage === totalPages} onClick={handleNext}>
                                <REAngleRight />
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
